<template>
  <transition name="product">
    <div class="ClueQuery">
      <van-nav-bar
        fixed
        :title="title"
        left-arrow
        @click-left="$router.go(-1)"
      ></van-nav-bar>
      <div class="fout-img">
        <img :src="fourimg" alt="" />
        <!-- <div class="img-font">
          <div class="font">联系人：</div>
          <div class="font">联系方式：</div>
        </div> -->
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      fourimg: "",
      fourimg1: require("@/assets/newindex/kexue.png"),
      fourimg2: require("@/assets/newindex/gaotie.png"),
      fourimg3: require("@/assets/newindex/shangquan.png"),
      fourimg4: require("@/assets/newindex/meishu.png"),
    };
  },
  methods: {},
  created() {
    this.title = this.$route.query.name;
    if (this.title == "西部(重庆)科学城九龙坡片区") {
      this.fourimg = this.fourimg1;
    } else if (this.title == "高铁临港经济区") {
      this.fourimg = this.fourimg2;
    } else if (this.title == "九龙新商圈") {
      this.fourimg = this.fourimg3;
    } else {
      this.fourimg = this.fourimg4;
    }
  },
};
</script>

<style lang="scss" scoped>
.ClueQuery {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
.fout-img {
  margin-top: 8vh;
  width: 100%;
  height: 600px;
  img {
    width: 100%;
    height: 70%;
  }
}
.font {
  border-radius: 8px;
  padding: 7px;
  background: #FFF;
  font-size: 14px;
  color: red;
  height: 36px;
  text-align: center;
  border: 1px solid red;
}
.img-font{
  margin: 20px;
  display: flex;
  justify-content: space-around;
}
</style>
